export default "__VITE_ASSET__BwoTK8Br__"